import classnames from "classnames";
import PropTypes from "prop-types";
import { ErrorMessage } from "../error-message";
import styles from "./styles";

export const Dropdown = ({
  id,
  ariaLabel,
  options,
  value,
  onChange,
  errorMessage,
  hasError,
  required,
  placeholder,
}) => {
  return (
    <>
      <select
        className={classnames(
          styles.select,
          hasError && styles.selectError,
          value === "" && styles.selectPlaceholder
        )}
        id={id}
        value={value}
        onChange={onChange}
        aria-label={ariaLabel}
        aria-required={required}
        aria-invalid={hasError}
        aria-describedby={hasError ? `error_${id}` : undefined}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {hasError && <ErrorMessage message={errorMessage} id={`error_${id}`} />}
    </>
  );
};

Dropdown.propTypes = {
  id: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  hasError: PropTypes.bool,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
};

Dropdown.defaultProps = {
  value: "",
  hasError: false,
  required: false,
  placeholder: "Select an option...",
};
